import React, {Component} from 'react';
import InputText from 'components/atoms/inputs/input-text';

interface Props {
    onSearch: (value) => void;
    value;
}

interface State {
    searchValue: string;
}

class SearchPlayer extends Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: props.value,
        };
    }
    onChange(value): void {
        this.setState({searchValue: value});
        this.props.onSearch(value);
    }
    render() {
        return (
            <div className="search-field">
                <InputText
                    placeholder="Find Player"
                    className="form-control"
                    value={this.state.searchValue}
                    onChange={this.onChange.bind(this)}
                />
                <i className="fa fa-search" />
            </div>
        );
    }
}

export default SearchPlayer;
